<template>
  <div class="business_container">
    <el-image :src="topImage" :fit="fit" class="mb-10 bs-10 br-10" style="width:100%;height:400px;display: block;"></el-image>
    <div v-for="(data,index) in datas" :key="index">
      <div v-if="index%2 == 0" class="mb-10 bs-10 br-10" style="padding: 10px; background: #FFF;">
        <div class="h-30"></div>
        <el-row>
          <el-col :span="24" class="title tal">{{data.title}}</el-col>
        </el-row>
        <div class="h-30"></div>
        <el-row :gutter="20" class="box">
          <el-col :span="12">
            <div class="left"><el-image :src="data.coverImage" :fit="fit" style="width:100%;height:100%"></el-image></div>
          </el-col>
          <el-col :span="12">
            <div class="right">
              <div class="content">
                <!--div class="subtitle">{{data.subTitle}}</div-->
                <div class="text" v-html="data.content"></div>
              </div>
              <div class="more">
                <el-button icon="el-icon-menu" @click="showDialog(index)">More</el-button>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-dialog
        :visible.sync="moreVisible" width="60%" center modal top="0" :lock-scroll=true custom-class="dialog-class">
          <div class="content-inner">
            <p style="font-weight: 700;margin-bottom: 20px;">{{dialog.title}}</p>
            <el-image :src="dialog.coverImage" style="max-width:640px;max-height:360px"></el-image>
            <div class="content-inner-text" v-html="dialog.content"></div>
          </div>
        </el-dialog>
      </div>
      <div v-else class="mb-10 bs-10 br-10" style="padding: 10px; background: #FFF;">
        <div class="h-30"></div>
        <el-row>
          <el-col :span="24" class="title tar">{{data.title}}</el-col>
        </el-row>
        <div class="h-30"></div>
        <el-row :gutter="20" class="box">
          <el-col :span="12">
            <div class="right">
              <div class="content">
                <!--div class="subtitle">{{data.subTitle}}</div-->
                <div class="text" v-html="data.content"></div>
              </div>
              <div class="more">
                <el-button  icon="el-icon-menu" @click="showDialog(index)">More</el-button>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="left"><el-image :src="data.coverImage" :fit="fit" style="width:100%;height:100%"></el-image></div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="h-30"></div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        moreVisible: false,
        dialog: {
          title: '',
          coverImage: '',
          content: ''
        },
        fit: 'fit',
        topImage: '',
        datas: []
      }
    },
    methods: {
      getData() {
        this.$axios.get('/api/business').then(res => {
            //console.log(res.data);
            if (res.data.code == '0') {
              this.datas = res.data.data;
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          })
          .catch(function(error) { // 请求失败处理
            console.log(error);
          });
      },
      getTopImage() {
        	this.$axios.get('/api/topimage/business').then(res => {
        			//console.log(res.data);
        			if (res.data.code == '0') {
                this.topImage = res.data.data[0].url;
                /*this.$message({
                	message: res.data.msg,
                	type: 'success',
                });*/
        			} else {
        				this.$message({
        					message: res.data.msg,
        					type: 'error'
        				})
        			}
        		})
        		.catch(function(error) { // 请求失败处理
        			console.log(error);
        		});
      },
      showDialog(index){
        //console.log(index);
        this.dialog.title = this.datas[index].title;
        this.dialog.coverImage = this.datas[index].coverImage;
        this.dialog.content = this.datas[index].content;
        this.moreVisible = true;
      }
    },
    mounted: function() {
      this.getTopImage();
      this.getData();
    }
  }
</script>

<style scoped>
  .business_container {
    max-width: 1200px;
    margin: 0 auto;
    min-height:200%;
  }

  .title {
    /*font-family: "microsoft yahei";
    font-family: "微软雅黑";*/
    font-family: "黑体";
    font-size: 24px;
  }

  .tal {
    text-align: left;
  }

  .tar {
    text-align: right;
  }

  .box {
    height: 375px;
  }

  .box .left {
    height: 375px;
    background-color: #409EFF;
  }

  .box .right {
    height: 375px;
  }

  .box .right .content {
    height: 315px;
    overflow: hidden;
  }

  .box .right .content .subtitle {
    font-size: 24px;
    font-weight: bold;
    line-height: 30px;
    text-align: left;
  }

  .box .right .content .text {
    font-size: 16px;
    line-height: 24px;
    text-align: left;
    /* margin-top: 15px; */
    overflow: hidden;
    margin-bottom: 15px;
  }

  .box .right .more {
    height: 40px;
    line-height: 40px;
    width: 100%;
    margin-top: 8px;
    text-align: left;
  }

  .bg {
    background-color: #409EFF;
  }

  .bg2 {
    background-color: #42B983;
  }

  .h-30 {
    height: 30px;
  }
  .content-inner {
    padding: 0 15px;
    text-align: center;
  }
  .content-inner-text {
    margin-top: 20px;
    text-align: left;
  }
</style>
<style>
  .el-dialog__wrapper {
    overflow-y: hidden;
  }
  .dialog-class {
    height: 100%;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/Business.vue